module.exports = __webpack_public_path__ + "static/media/soc-r-en.dbdda9d4.png";